/**
 * Two colours only: pink for leads still moving forward, grey for leads that
 * stopped. Lead source colours are deliberately not used on the ribbons — the
 * chart is read left to right for progression, and per-source colour is what
 * Leads by source is for.
 */
export const JOURNEY_TONES = {
  progressed: "#E6007E",
  stalled: "#B7B7B7",
  // A step no lead in the cohort reached. It still earns a column — "no
  // showings were scheduled" is the answer the chart exists to give — but it
  // must not read as flow, so it is drawn flat and almost out of the way.
  empty: "#DCDCDC"
} as const;

export const JOURNEY_GEOMETRY = {
  // Width of a node's bar, and the corner radius that rounds it off.
  nodeWidth: 10,
  nodeRadius: 5,
  // The "Leads created" bar is drawn at this height; every other value scales
  // against it, so the chart reads as a share of the total at a glance.
  rootHeight: 250,
  // Nothing narrower than this is visible, so tiny values get a floor rather
  // than vanishing.
  minNodeHeight: 3,
  minRibbonHeight: 1.5,
  // Vertical breathing room between stacked drop-off bands.
  bandGap: 12,
  // Minimum centre-to-centre distance between two stacked pills.
  bandPitch: 30,
  // How far a pill hangs below its node's edge.
  labelDrop: 8,
  pillHeight: 24,
  paddingX: 12,
  paddingBottom: 20,
  // Floor for the gap between two columns, before pill widths widen it.
  minColumnGap: 120,
  // Vertical clearance a skip ribbon keeps from the one beneath it.
  skipLaneGap: 10,
  // Flat tick a milestone nothing reached is drawn as, in place of a bar.
  // Unreached milestones are no longer drawn at all, so this is only the floor
  // a zero-height node would fall back to.
  emptyNodeHeight: 2
} as const;

export const JOURNEY_HELP_TEXT =
  "Every lead created in the selected period, followed forward to the furthest " +
  "milestone it has reached so far — even if that happened after the period ended. " +
  "Leads created before the period are not included, so each step contains only " +
  "leads from the step before it. Leads that stopped short branch off into Not " +
  "interested, Unresponsive or Still in progress. Each lead is counted once.";

export const JOURNEY_EMPTY_DESCRIPTION =
  "No leads were created in this date range";
